/** Copy of the retailerReceipts page (Operations), ported from VentaHub. */
export const retailerReceipts = {
  words: {
    noun: 'receipt',
    record: 'Record a receipt',
    document: 'sales invoice',
    settled: 'received',
  },
  title: 'Retailer receipts',
  description: 'Money received from retailers against sales invoices.',
  empty: 'No retailer receipts to show',
  emptyHint: 'Nothing matches these filters.',
  filters: {
    warehouse: 'Warehouse',
    party: 'Retailer',
    invoice: 'Sales invoice',
    dates: 'Received on',
    void: 'Include voided',
  },
  columns: {
    date: 'Received on',
    invoice: 'Invoice',
    amount: 'Amount',
    comment: 'Comment',
    valid: 'Status',
  },
} as const
